import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const zigzageldConfig: TSPConfig = {
  key: 'zigzageld',
  name: 'ZigZag ELD',
  imageName: 'ZigZagELD',
  category: TSPCategory.CUSTOM,
  helpText:
    'Please input the username, password, and Company ID from your ZigZag ELD account.',
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        {
          label: 'Username',
          name: 'username',
          type: 'text',
          required: true,
        },
        {
          label: 'Password',
          name: 'password',
          type: 'password',
          required: true,
        },
        {
          label: 'Company ID',
          name: 'apikey',
          type: 'text',
          required: true,
        },
      ]}
    />
  ),
};

export default zigzageldConfig;
